import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import GuestGuard from './components/Auth/GuestGuard';
import AuthGuard from './components/Auth/AuthGuard';

import { BASE_URL } from './config/constant';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  {
    exact: 'true',
    guard: GuestGuard,
    path: '/login',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/404',
    element: lazy(() => import('./views/errors/NotFound404'))
  },
  {
    exact: 'true',
    path: '/maintenance/coming-soon',
    element: lazy(() => import('./views/maintenance/ComingSoon'))
  },
  {
    exact: 'true',
    path: '/maintenance/error',
    element: lazy(() => import('./views/maintenance/Error'))
  },
  {
    exact: 'true',
    path: '/maintenance/offline-ui',
    element: lazy(() => import('./views/maintenance/OfflineUI'))
  },
  {
    exact: 'true',
    path: '/auth/signin-1',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/auth/signup-1',
    element: lazy(() => import('./views/auth/signup/SignUp1'))
  },
  {
    exact: 'true',
    path: '/auth/reset-password-1',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword1'))
  },
  {
    exact: 'true',
    path: '/auth/change-password',
    element: lazy(() => import('./views/auth/ChangePassword'))
  },
  {
    exact: 'true',
    path: '/auth/profile-settings',
    element: lazy(() => import('./views/auth/ProfileSettings'))
  },

  {
    path: '*',
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      // {
      //   exact: 'true',
      //   path: '/sample-page',
      //   element: lazy(() => import('./views/extra/SamplePage'))
      // },

      {
        exact: 'true',
        path: '/users/userList',
        element: lazy(() => import('./views/users/index'))
      },
      {
        exact: 'true',
        path: '/service-providers',
        element: lazy(() => import('./views/serviceProviders.js/index'))
      },
      {
        exact: 'true',
        path: '/business',
        element: lazy(() => import('./views/business/index'))
      },
      {
        exact: 'true',
        path: '/category',
        element: lazy(() => import('./views/category/index'))
      },
      {
        exact: 'true',
        path: '/manage-booking',
        element: lazy(() => import('./views/booking/index'))
      },
      {
        exact: 'true',
        path: '/profile/edit-profile',
        element: lazy(() => import('./views/profile/editprofile'))
      },
      {
        exact: 'true',
        path: '/help-support',
        element: lazy(() => import('./views/help-support/index'))
      },
      {
        exact: 'true',
        path: '/post/details',
        element: lazy(() => import('./views/post/ReportsData'))
      },
      {
        exact: 'true',
        path: '/post/data/details',
        element: lazy(() => import('./views/post/ReportsDataDetails'))
      },
      {
        exact: 'true',
        path: '/help-request/request-list',
        element: lazy(() => import('./views/help_request/HelpRequestListing'))
      },
      {
        path: '*',
        exact: 'true',
        element: () => <Navigate to={BASE_URL} />
      }
    ]
  }
];

export default routes;
